module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-detail-bill"
  }, [_c('navbar', {
    attrs: {
      "title": "餐企报价单-明细"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "common-scroll detail-scroll"
  }, [_c('p', {
    staticClass: "detail-bill-status"
  }, [_vm._v("订单号：" + _vm._s(_vm.billDetailData.trans_bill_no) + "\n\t\t\t"), _c('span', {
    staticClass: "nav-btn",
    on: {
      "click": function($event) {
        return _vm.openBillInfo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/nav-btn.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.billDetailData.bill_state == 30) ? _c('span', {
    staticClass: "state-grey-font"
  }, [_vm._v("未确认")]) : _vm._e(), _vm._v(" "), (_vm.billDetailData.bill_state == 31) ? _c('span', {
    staticClass: "state-aqua-font"
  }, [_vm._v("已同意")]) : _vm._e(), _vm._v(" "), (_vm.billDetailData.bill_state == 32) ? _c('span', {
    staticClass: "state-red-font"
  }, [_vm._v("已确认")]) : _vm._e(), _vm._v(" "), (_vm.billDetailData.bill_state == 35 && _vm.isZ5) ? _c('span', {
    staticClass: "state-red-font"
  }, [_vm._v("已定价")]) : _vm._e(), _vm._v(" "), (_vm.billDetailData.bill_state == 39) ? _c('span', {
    staticClass: "state-grey-font"
  }, [_vm._v("已退回")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.billInfoShow),
      expression: "billInfoShow"
    }],
    staticClass: "bill-all-info bill-all-info-background"
  }, [_c('ul', {
    staticClass: "detail-bill-info-list detail-bill-info-list-background"
  }, [_c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("报价企业：" + _vm._s(_vm.billDetailData.restaurant_name))]), _vm._v(" "), (_vm.billDetailData.in_date && _vm.billDetailData.in_date.length) ? _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-remark"
  }, [_vm._v("\n\t\t\t\t\t报价截止时间：" + _vm._s(_vm.formatDate(_vm.billDetailData.in_date)) + "\n\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-search-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchWord),
      expression: "searchWord"
    }],
    staticClass: "detail-search-input",
    attrs: {
      "placeholder": "请输入要搜索的品项名称"
    },
    domProps: {
      "value": (_vm.searchWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWord = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-wrapper"
  }, [_c('h4', {
    staticClass: "detail-bill-address aqua-font"
  }, [_vm._v("\n\t\t\t\t明细条目(" + _vm._s(_vm.detailsFilter.length) + ")\n\t\t\t\t"), (_vm.billDetailData.bill_state == 31) ? _c('router-link', {
    staticClass: "detail-bill-edit state-aqua-font",
    attrs: {
      "to": {
        path: '/detail-quotation-edit',
        query: {
          bill_id: _vm.queryData.bill_id,
          searchWord: _vm.searchWord
        }
      },
      "replace": ""
    }
  }, [_vm._v("编辑")]) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "detail-bill-list width-full"
  }, _vm._l((_vm.detailsFilter), function(billDetail) {
    return _c('li', {
      key: billDetail.goods_id,
      staticClass: "width-full"
    }, [_c('ul', {
      staticClass: "detail-bill-sonlist width-full"
    }, [_c('li', {
      staticClass: "detail-bill-fulllist detail-bill-list-title detail-bill-list-title-line"
    }, [_c('div', [_vm._v(_vm._s(billDetail.goods_name) + "(" + _vm._s(billDetail.goods_unit) + ")")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isZ5 && _vm.billDetailData.bill_state == 35),
        expression: "isZ5 && billDetailData.bill_state == 35"
      }],
      staticClass: "detail-bill-list-title-right"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(billDetail.pricing_state == 1 ? '中标' : '未中标') + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), (_vm.isPesc) ? _c('li', [_vm._v("规格：" + _vm._s(billDetail.goods_spec))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("税率：" + _vm._s(billDetail.goods_cess) + " %")]), _vm._v(" "), _c('li', [_vm._v("含税单价：" + _vm._s(_vm._f("numFixed")(billDetail.goods_price_send, _vm.numScale)) + " 元")]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (billDetail.goods_price_recipient >= 0),
        expression: "billDetail.goods_price_recipient >= 0"
      }]
    }, [_vm._v("上次价格档案单价：\n\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("numFixed")(billDetail.goods_price_recipient, _vm.numScale)) + " 元")])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isZ5 && _vm.inquiryAmountFlag),
        expression: "isZ5 && inquiryAmountFlag"
      }]
    }, [_vm._v("询价数量：" + _vm._s(_vm._f("numFixed")(billDetail.goods_num_sended, 4)))]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isZ5 && (billDetail.is_compare_price == 1)),
        expression: "isZ5 && (billDetail.is_compare_price == 1)"
      }]
    }, [_vm._v("参考含税单价：" + _vm._s(_vm._f("numFixed")(billDetail.reference_price, 4)))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "detail-bill-footer"
  }, [_c('div', {
    staticClass: "detail-bill-info",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.billDetailData.bill_state == 30) ? _c('div', {
    staticClass: "detail-bill-return f-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.agreen(31)
      }
    }
  }, [_vm._v("同意")])]) : _vm._e(), _vm._v(" "), (_vm.billDetailData.bill_state == 30 || _vm.billDetailData.bill_state == 31) ? _c('div', {
    staticClass: "detail-bill-red f-right"
  }, [_c('a', {
    on: {
      "click": _vm.refuseB
    }
  }, [_vm._v("退回")])]) : _vm._e(), _vm._v(" "), (_vm.billDetailData.bill_state == 31) ? _c('div', {
    staticClass: "detail-bill-return f-right"
  }, [_c('a', {
    on: {
      "click": _vm.billConfirm
    }
  }, [_vm._v("确认")])]) : _vm._e(), _vm._v(" "), (_vm.billDetailData.bill_state != 30 && _vm.billDetailData.bill_state != 39) ? _c('div', {
    staticClass: "detail-bill-return f-right",
    staticStyle: {
      "border-right": "solid 1px #fff"
    }
  }, [_c('a', {
    on: {
      "click": _vm.importExcel
    }
  }, [_vm._v("Excel")])]) : _vm._e()])]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsB),
      expression: "tipsB"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatusB
    }
  }), _vm._v(" "), _c('tips-t', {
    ref: "tipsTShow",
    attrs: {
      "hasTipsFont": "",
      "btnFont": _vm.btnFont,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.getStatues
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d1c529f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/QuotationDetailBill.vue
// module id = 597
// module chunks = 1